(function () {
  angular
    .module("akitabox.desktop.schedule.detail")
    .controller("ScheduleRoomTabController", ScheduleRoomTabController);

  /* @ngInject */
  function ScheduleRoomTabController(
    // Angular
    $timeout,
    // Resolves
    building,
    schedule,
    // Services
    RoomService,
    ToastService
  ) {
    var self = this;

    // Attributes
    self.loading = true;
    self.rendering = true;
    self.building = building;
    self.schedule = schedule;
    self.room = null;

    init();

    function init() {
      var roomId = schedule.room._id;
      var params = { include_values: true };
      var options = {
        includePinType: true,
        includeFloor: true,
      };
      RoomService.getById(building._id, roomId, params, options)
        .then(function (room) {
          self.room = room;
        })
        .catch(ToastService.showError)
        .finally(function () {
          self.loading = false;
          $timeout(function () {
            self.rendering = false;
          }, 500);
        });
    }
  }
})();
